import React from 'react';
import {Route, Switch} from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import {Dashboard} from "../pages/Dashboard";
import auth from "../auth/auth"
import {ImportData} from "../pages/Import_data";
import {Actions} from "../pages/actions/Actions";
import {ViewClassAttendance} from "../pages/actions/ViewClassAttendance";
import {ViewNoneCreatedByModifiedByEntity} from "../pages/actions/ViewNoneCreatedByModifiedByEntity";

const Routes = props => {
    return (
        <Switch>
            <ProtectedRoute path={`/dashboard`} hide_bc permission={true} component={Dashboard}/>
            <ProtectedRoute path={`/actions/view-class-attendance`} hide_bc permission={true} component={ViewClassAttendance}/>
            <ProtectedRoute path={`/actions/view-none-created-by-modified-by-entity`} hide_bc permission={true} component={ViewNoneCreatedByModifiedByEntity}/>
            <ProtectedRoute path={`/actions`} hide_bc permission={true} component={Actions}/>
            <ProtectedRoute path={`/import-data`} permission={true} component={ImportData}/>

            <Route path="*" render={() => auth.logout()}/>
        </Switch>

    );
}


export default Routes;
